import React, { useRef } from 'react';
import { motion, useInView, useReducedMotion } from 'framer-motion';
type AnimatedSectionProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};
export function AnimatedSection({
  children,
  className = '',
  delay = 0
}: AnimatedSectionProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const shouldReduceMotion = useReducedMotion();
  return <motion.div ref={ref} initial={shouldReduceMotion ? false : {
    opacity: 0,
    y: 16
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : undefined} transition={{
    duration: shouldReduceMotion ? 0 : 0.26,
    delay: shouldReduceMotion ? 0 : delay,
    ease: [0.23, 1, 0.32, 1]
  }} className={className} data-id="element-1" data-mp="32xz72fj7ax95">
      {children}
    </motion.div>;
}